import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';
// mui
// import zhLocale from 'element-ui/src/locale/lang/zh-CN';
// import enLocale from 'element-ui/src/locale/lang/en';
// import jpLocale from 'element-ui/src/locale/lang/ja';
// 自定义
import indexLang from './modules/index/index';
import devLang from './modules/developer/index';
import systemLang from './modules/system/index';
import networkLang from './modules/network/index';
import componentsLang from './components/index';
// 二级节点
import snLang from './modules/sn/index';

import langApi from './api/lang';
// 语言代码对应element ui语言包映射
const elementLangMap = {
    'zh-CN': 'zh-CN',
    'zh-TW': 'zh-TW',
    'zh-HK': 'zh-TW',
    'ru-RU': 'ru-RU',
    'en-US': 'en',
    'ja-JP': 'ja',
    'ko-KR': 'ko'
};
// 组件 语言包映射
const componentLangMap = {
    'zh-CN': 'zh',
    'en-US': 'en',
    'ja-JP': 'ja'
};
/**
 * 按照语言动态加载对应的Element组件Lang包
 * @param elementLangs
 */
const loadElementLang = async (elementLangs) => {
    const loadLangList = elementLangs.slice(0);
    const allLoadElementsLang = elementLangs.map(modName => {
        return require(`element-ui/src/locale/lang/${elementLangMap[modName]}`);
    });
    return Promise.all(allLoadElementsLang).then(res => {
        const elementLangs = {};
        for (let i = 0; i < res.length; i++) {
            const langName = loadLangList[i];
            elementLangs[langName] = res[i].default;
        }
        return elementLangs;
    });
};

export default {
    async initLanguage(userLang) {
        // 用户设置的语言>浏览器的语言>默认语言
        const navLang = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
        const localLang = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'ja-JP') ? navLang : false;
        const cacheLang = localStorage.getItem('lang');
        const lang = userLang || cacheLang || localLang || 'zh-CN';
        Vue.use(VueI18n);

        // 懒加载element语言包
        const elementLangs = await loadElementLang([lang]);
        // 加载模块语言包
        // const componentsLang = await loadModuleLang.then(res => res);
        const localCache = JSON.parse(localStorage.getItem('langInfo')) || {};
        let RemoteLangCache = {};
        if (localCache.hasOwnProperty(lang)) {
            RemoteLangCache = localCache[lang];
        }
        const LangVersion = RemoteLangCache.versionCode ? RemoteLangCache.versionCode : 0;
        const params = {
            versionCode: LangVersion,
            langCode: lang
        };
        let langData = {};
        // 为以防翻译接口资源报异常导致整个页面报错，异步加载语言包的的错误一律不抛出
        try {
            langData = await langApi.getLang(params);
        } catch (e) {
            langData = {
                data: {

                }
            };
        }
        langData = langData.data;
        if (langData.list) {
            langData.backList = langData.list.slice(0);
            const langDataList = {};
            // 语言数据转key-value对应
            for (let i = 0; i < langData.list.length; i++) {
                langDataList[langData.list[i].code] = langData.list[i].content || '';
            }
            langData.list = langDataList;
        }
        const langInfo = {};

        if (langData.versionCode && (langData.versionCode !== params.langVersion) && (langData.backList.length > 0)) {
            // 更新语言包
            delete langData.backList;
            localCache[lang] = langData;
            localStorage.setItem('langInfo', JSON.stringify(localCache));
            langInfo[lang] = langData.list;
        } else {
            langInfo[lang] = RemoteLangCache.list ? RemoteLangCache.list : {};
        }
        localStorage.setItem('lang', lang);

        // 合并所有语言
        const messages = store.getters.langInfo || {};
        messages[lang] = Object.assign(
            {},
            { siteIndex: indexLang[componentLangMap[lang]] },
            { developer: devLang[componentLangMap[lang]] },
            { network: networkLang[componentLangMap[lang]] },
            { system: systemLang[componentLangMap[lang]] },
            { components: componentsLang[componentLangMap[lang]] },
            { sn: snLang[componentLangMap[lang]] },
            { panelPoint: snLang[componentLangMap[lang]] },
            elementLangs[lang],
            { lang: langInfo[lang] }
        );
        store.commit('updateLangInfo', messages);
        store.commit('updateLocale', lang);
        return messages[lang];
    }

    // initLanguage(userLang) {
    //     // 用户设置的语言>浏览器的语言>默认语言
    //     const navLang = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
    //     const localLang = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'ja-JP') ? navLang : false;
    //     const lang = userLang || localLang || 'zh-CN';
    //     Vue.use(VueI18n);
    //     return new VueI18n({
    //         locale: lang,
    //         messages: {
    //             'zh-CN': Object.assign({}, { siteIndex: indexLang.zh }, { developer: devLang.zh }, { network: networkLang.zh },
    //                 { system: systemLang.zh }, { components: componentsLang.zh }, zhLocale, { panelPoint: snLang.zh }),
    //             'en-US': Object.assign({}, { siteIndex: indexLang.en }, { developer: devLang.en }, { network: networkLang.en },
    //                 { system: systemLang.en }, { components: componentsLang.en }, enLocale, { panelPoint: snLang.zh }),
    //             'ja-JP': Object.assign({}, { siteIndex: indexLang.ja }, { developer: devLang.ja }, { network: networkLang.ja },
    //                 { system: systemLang.ja }, { components: componentsLang.ja }, jpLocale, { panelPoint: snLang.zh })
    //         }
    //     });
    // }
};
